module.exports = __webpack_public_path__ + "static/media/Group 81.f6a0d74a.svg";